import axios from 'axios'
import qs from 'qs'
import { base } from './config'

// 登录
export const LOGIN = params => { return axios.post(`${base}/client/user/login`, qs.stringify(params)) }

// 获取学校列表
export const SCHOOL_LIST = params => { return axios.get(`${base}/client/structure/school/items`, { params }) }

// 获取院系列表
export const COLLEGE_LIST = params => { return axios.get(`${base}/client/structure/department/items`, { params }) }

// 获取专业班级
export const CLS_LIST = params => { return axios.get(`${base}/client/structure/profession_class/items`, { params }) }

// 获取团体订单
export const GROUP_ORDER = params => { return axios.get(`${base}/client/order/items_group`, { params }) }

// 获取个人订单
export const PERSON_ORDER = params => { return axios.get(`${base}/client/order/items_person`, { params }) }

// 登录-普通会员
export const LOGIN_MEMBER = params => { return axios.post(`${base}/client/user/login`, qs.stringify(params)) }

// 登录-管理员
export const LOGIN_ADMIN = params => { return axios.post(`${base}/client/admin/login`, qs.stringify(params)) }

// 获取用户信息-普通会员
export const USER_INFO = params => { return axios.get(`${base}/client/user/info`, { params }) }

// 获取用户信息-管理员
export const ADMIN_INFO = params => { return axios.get(`${base}/client/admin/info`, { params }) }

// 退出-会员
export const LOGOUT_MEMBER = params => { return axios.get(`${base}/client/user/logout`, { params }) }

// 退出-管理员
export const LOGOUT_ADMIN = params => { return axios.get(`${base}/client/admin/logout`, { params }) }

// 编辑用户资料
export const EDIT_USER_INFO = params => { return axios.post(`${base}/client/user/edit`, params) }

// 查询用户订单-会员(团体)
export const MEMBER_ORDER = params => { return axios.get(`${base}/client/order/items_user`, { params }) }

// 查询用户订单-会员(会员)
export const MEMBER_ORDER_PERSON = params => { return axios.get(`${base}/client/order/items_user_person`, { params }) }

// 查询个人订单详情
export const PERSONAL_ORDER_DETAIL = params => { return axios.get(`${base}/client/order/items_user_person/detail`, { params }) }

// 用户申请退款
export const REFUND = params => { return axios.post(`${base}/client/refund/apply_user`, params) }

// 上传图片
export const UPLOAD_REFUND_IMG = params => { return axios.post(`${base}/client/refund/upload_img`, params) }

// 出版社数据-按类别搜索
export const PRESS_INFO = params => { return axios.get(`${base}/client/textbook/items`, { params }) }

// 出版社数据-keyword模糊搜索
export const PRESS_INFO_BLUR = params => { return axios.get(`${base}/client/textbook/search/items`, { params }) }

// 图书馆登录
export const LOGIN_LIBRARY = params => { return axios.post(`${base}/client/library/user/login`, qs.stringify(params)) }

// 查询图书馆书目列表
export const TEXTBOOK_LIST = params => { return axios.get(`${base}/client/library/book/items`, { params }) }

// 退款列表
export const REFUND_LIST = params => { return axios.get(`${base}/client/refund/items_admin`, { params }) }

// 管理员审核退款
export const CHECK_REFUND_APPLY = params => { return axios.post(`${base}/client/refund/check_admin`, qs.stringify(params)) }

// 管理员订单
export const ADMIN_ORDER_LIST = params => { return axios.get(`${base}/client/order/items_admin`, { params }) }

// 管理员修改订单状态 
export const CANCEL_ORDER_CONFIRM = params => { return axios.post(`${base}/client/order/convert`, qs.stringify(params)) }

// 管理员确认订单-编辑实领数
export const CONFIRM_ORDER = params => { return axios.post(`${base}/client/order/edit_receive`, qs.stringify(params)) }

// 注册 
export const REGISTER = params => { return axios.post(`${base}/client/user/register`, qs.stringify(params)) }

// 获取短信验证码
export const SMS_CODE = params => { return axios.get(`${base}/client/sms/code`, { params }) }

// 忘记密码（重置密码）
export const RESET_PWD = params => { return axios.post(`${base}/client/user/reset_pwd`, qs.stringify(params)) }

// 微信公众号扫码支付
export const WECHAT_PAY = params => { return axios.post(`${base}/client/pay/wx_official_scan`, qs.stringify(params)) }

// 支付宝扫码支付
export const ALI_PAY = params => { return axios.post(`${base}/client/pay/ali_scan`, qs.stringify(params)) }

// 第三方登录绑定手机号
export const BIND_PHONE = params => { return axios.post(`${base}/client/oauth/bind_user`, qs.stringify(params)) }

// 获取公告
export const NOTICE_LIST = params => { return axios.get(`${base}/client/announcement/items_current`,{params}) }


// WEBPACK FOOTER //
// ./src/api/index.js